import RadioButton from "../../shared/form/fields/RadioButton";
import { every, isEmpty, map, some } from "lodash";
import QuestionTypeFields from "./QuestionTypeFields";

type QuestionFieldsArgs = {
  selectedType: string;
};

export default function QuestionFields({ selectedType }: QuestionFieldsArgs) {
  function renderQuestionTypeFields(type: string) {
    switch (type) {
      case "question":
        return;
      case "survey":
        return (
          <QuestionTypeFields
            options={["option_adding", "multiple_select", "anonymous"]}
            name="object.options"
            type="survey"
            additionalOptionLabel={I18n.t(
              "js.activitystreams.additional_option",
            )}
            validate={(value) =>
              (value && value.length > 0 && !every(value, { label: "" })) ||
              I18n.t("js.activity.validation.add_option_to_survey_error")
            }
          />
        );
      case "schedule":
        return (
          <QuestionTypeFields
            options={[
              "option_adding",
              "multiple_select",
              "add_improper_schedule_option",
            ]}
            name="object.proposals"
            type="schedule"
            additionalOptionLabel={I18n.t(
              "js.composer.editor.schedule.new_proposal",
            )}
            validate={(value) => {
              if (!value || value.length === 0) {
                return I18n.t(
                  "js.activity.validation.add_option_to_survey_error",
                );
              }

              if (some(value, (val) => isEmpty(val.date))) {
                return I18n.t(
                  "js.activity.validation.date_in_proposal_not_present",
                );
              }

              return true;
            }}
          />
        );
    }
  }
  return (
    <div className="flex flex-col gap-2 divide-y divide-neutral/25 *:pt-2 -mt-4">
      <RadioButton
        name="object.type"
        options={map(["question", "survey", "schedule"], (type) => ({
          label: I18n.t(`js.composer.editor.${type}.label`),
          value: type,
        }))}
        withoutWrapper
      />
      {renderQuestionTypeFields(selectedType)}
    </div>
  );
}
